import { Helmet } from "react-helmet";
import Layout from "../Shared/Layout";
import Banner from "./Banner";
import Category from "./Categoty";
import CustomerSaySection from "./CustomerSaySection";
import Occasion from "./Occasion";
import ProductDetailSection from "./ProductDetailSection";
import RecommendedProduct from "./RecommendedProduct";
import ServicesSection from "./ServicesSection";
import TopProducts from "./TopProducts";

const Home = () => {

    return (
        <Layout>
            <Helmet>
                {/* Title Tag */}
                <title>
                    Gailee - Exquisite Chikankari-Inspired Hand-Stitched Kurtas
                    {/* | Gailee - Hand-Stitched, Chikankari-Inspired Kurtas for Modern Women */}
                </title>
                {/* Meta Description */}
                <meta
                    name="description"
                    content="Discover Gailee's hand-stitched kurtas, inspired by traditional chikankari designs. Experience timeless elegance and modern comfort in every piece. Discover Gailee's exclusive collection of hand-stitched kurtas inspired by traditional chikankari. Perfect for festive, office, and everyday wear."
                />
                {/* Open Graph Tags */}
                <meta property="og:title" content="Gailee - Chikankari-Inspired Kurtas for Women" />
                <meta property="og:description" content="Celebrate heritage with Gailee’s hand-stitched ethnic kurtas, inspired by chikankari craftsmanship." />
                <meta property="og:image" content="https://gailee.in/images/banner.jpg" />
                <meta property="og:url" content="https://gailee.in/" />

            </Helmet>
            <div className="home_layout_container">
                {/* H1 tag for SEO only, not visible on page */}
                <h1 style={{ display: "none" }}>
                    Welcome to Gailee - Hand-Stitched Chikankari-Inspired Kurtas
                </h1>
                <Banner />
                <Category />
                <TopProducts />
                <RecommendedProduct />
                <ProductDetailSection />
                <Occasion />
                <CustomerSaySection />
                <ServicesSection />
            </div>
        </Layout>
    );
};

export default Home;